import { Component, computed, inject, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { TextImageComponent } from '@content/ui/text-image';
import {
  ImageField,
  LinkField,
  RichTextField,
  TextField,
} from '@core/jss-proxy';
import { getField } from '@core/jss-utils';
import { Store } from '@ngrx/store';
import { getAppStoreButton, getGooglePlayButton } from '@core/navigation-store';
import { AppStoreButtonsComponent } from '@core/navigation-ui';
import {
  computedContentSectionId,
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';

@Component({
  selector: 'wl-text-image-container',
  templateUrl: './text-image.container.component.html',
  standalone: true,
  imports: [
    TextImageComponent,
    AppStoreButtonsComponent,
    ContentSectionComponent,
  ],
})
export class TextImageContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();
  readonly id = computedContentSectionId(this.rendering);
  readonly theme = computedContentSectionTheme(this.rendering);

  readonly inverse = computed(
    () => this.rendering().params?.showInverse === '1'
  );

  readonly fields = computed(() => this.rendering().fields);
  readonly title = computed(() => getField<TextField>(this.fields(), 'title'));
  readonly content = computed(() =>
    getField<RichTextField>(this.fields(), 'content')
  );
  readonly image = computed(() => getField<ImageField>(this.fields(), 'image'));
  readonly primaryButton = computed(() =>
    getField<LinkField>(this.fields(), 'primaryButton')
  );
  readonly secondaryButton = computed(() =>
    getField<LinkField>(this.fields(), 'secondaryButton')
  );
  readonly microcopy = computed(() =>
    getField<TextField>(this.fields(), 'microcopy')
  );

  readonly showAppStoreButtons = computed(
    () => this.rendering().componentName === 'TextImageAppSection'
  );

  readonly #store = inject(Store);
  readonly appStoreButton = this.#store.selectSignal(getAppStoreButton);
  readonly googlePlayButton = this.#store.selectSignal(getGooglePlayButton);
}
